// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"627":"f74b6adc","934":"33ed8970","958":"212f06e2"}[chunkId] + ".chunk.js";
};